import DeleteSponsorshipTier from "./DeleteSponsorshipTier";

export default DeleteSponsorshipTier